import { TaskKind, TaskItem } from '@/entities/tasks/model/types'

export function getTaskVariant(type: number): Pick<TaskItem, 'variant'>['variant'] {
  return type === TaskKind.FRIENDS ? 'counter' : 'completion'
}
